import React from "react";
import { components } from "react-select";
import { string, bool } from "prop-types";

const Option = ({ label, isSelected, ...rest }) => {
  return (
    <div className="select__options">
      <components.Option {...rest}>
        <div className="select__options">
          <div className="select__checkbox">
            <input
              aria-label="checkbox"
              type="checkbox"
              checked={isSelected}
              onChange={() => null}
            />
            <span className="checkmark"></span>
          </div>
          <div className="select__label">
            <label>{label}</label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};

Option.propTypes = {
  label: string,
  isRequired: bool,
};

export default Option;
